import { SectionDivider } from "app/components/shared/SectionDivider";
import { WhyAnsibleList, Ansible_Reason } from "./constants";
import { Flex, Box, Heading, Text } from "@chakra-ui/react";

const WhyAnsible = () => {
  return (
    <Box data-cy="section-why-ansible">
      <SectionDivider label="What is Ansible ?" padding="0 2rem" />
      {Ansible_Reason.map((Reason, index) => (
        <Text key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
          {Reason}
        </Text>
      ))}
      <SectionDivider label="Why Choose Ansible for Network DevOps?" padding="0 2rem" />
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        gap={"2%"}
        data-cy={"card-pricing"}
        mt={10}
      >
        {WhyAnsibleList.map((data, index) => (
          <Box
            p={6}
            key={index}
            boxShadow={"md"}
            border={"1px solid #aaa"}
            borderRadius={"8px"}
            transition={"0.15s"}
            _hover={{
              transform: "scale(1.03)",
              boxShadow: "lg",
            }}
            height={"auto"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={"4px"}
            minWidth={"320px"}
            maxWidth={"24%"}
            marginBottom={8}
          >
            <Heading
              as={"h3"}
              textAlign={"center"}
              fontSize={{ base: "md", lg: "lg" }}
              color={"gray.700"}
              mb={3}
            >
              {data.title}
            </Heading>

            <Text key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
              {data.desc}
            </Text>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default WhyAnsible;
